// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_SimulateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /subaccounts/anticipations/simulate
 *
 * dados is an object with two fields:
 *
 *   - simulation   ← AsaasProvider::normalizeAnticipationResponse() enriched
 *                    with the four `*_display` money fields. Fully typed by
 *                    SubaccountsAnticipations_SimulateSimulationRow — every
 *                    field is enumerated from the normalizer + controller.
 *   - raw_response ← the verbatim upstream ASAAS /anticipations/simulate
 *                    response. Genuinely dynamic provider passthrough whose
 *                    schema is owned by ASAAS (fields beyond the ones the
 *                    normalizer consumes can appear/change without our code);
 *                    typing it would be guessing, so it stays a justified
 *                    untyped passthrough — NOT a whole-dados erasure.
 *
 * @see anticipations.php::simulate()
 * @see AsaasProvider::simulateAnticipation()
 * @see AsaasProvider::normalizeAnticipationResponse()
 */
import type { SubaccountsAnticipations_SimulateSimulationRow } from './SubaccountsAnticipations_SimulateSimulationRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_SimulateResponseDados {
simulation: SubaccountsAnticipations_SimulateSimulationRow
raw_response: unknown[]
}

export type SubaccountsAnticipations_SimulateResponse = ApiResponse<SubaccountsAnticipations_SimulateResponseDados>;

registerResponseContract('SubaccountsAnticipations_SimulateResponse', {
  simulation: {
    type: 'object',
    required: true,
    fields: {
      provider_anticipation_id:   { type: 'string',  required: false },
      provider_payment_id:        { type: 'string',  required: false },
      provider_installment_id:    { type: 'string',  required: false },
      status:                     { type: 'string',  required: true },
      request_date:               { type: 'string',  required: true },
      anticipation_date:          { type: 'string',  required: false },
      due_date:                   { type: 'string',  required: false },
      anticipation_days:          { type: 'number',  required: false },
      total_value_cents:          { type: 'number',  required: true },
      anticipation_value_cents:   { type: 'number',  required: true },
      fee_cents:                  { type: 'number',  required: true },
      net_value_cents:            { type: 'number',  required: true },
      denial_observation:         { type: 'string',  required: false },
      total_value_display:        { type: 'number',  required: true },
      anticipation_value_display: { type: 'number',  required: true },
      fee_display:                { type: 'number',  required: true },
      net_value_display:          { type: 'number',  required: true },
    },
  },
  raw_response: { type: 'array',   required: true },
})
